import ahoy from "ahoy.js"

if (window.location.pathname.startsWith("/admin")) {
  ahoy.configure({ eventsUrl: "/ahoy/events?admin=true" })
}

export { ahoy }
